const toFiniteNumber = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
};

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export const formatUsd = (value) => USD_FORMATTER.format(toFiniteNumber(value));

export const formatUsdCompact = (value) => {
    const numeric = toFiniteNumber(value);
    return numeric === 0
        ? formatUsd(0)
        : `$${new Intl.NumberFormat('en-US', {
            notation: 'compact',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(numeric)}`;
};

export const asFiniteNumber = toFiniteNumber;
